<div class="cielo-container">
  <div class="cielo-content">
    <ng-container *ngIf="!paymentSuccess; else successMsg">
      <form [formGroup]="paymentForm" autocomplete="off" novalidate>
        <!-- Título da forma de pagamento -->
        <div class="payment-title">
          <h3 *ngIf="isCredito">Pagamento com Cartão de Crédito</h3>
          <h3 *ngIf="isDebito">Pagamento com Cartão de Débito</h3>
        </div>

        <!-- Parcelamento (apenas para crédito) -->
        <div class="form-group" *ngIf="isCredito && permiteParcelamento">
          <label for="installments">Parcelamento</label>
          <div class="custom-select-wrapper">
            <select formControlName="installments" class="form-control" [disabled]="loadingPayment || isDebito">
              <option *ngFor="let parcela of parcelas" [value]="parcela.value">
                {{ parcela.label }}
              </option>
            </select>
          </div>
        </div>

        <!-- Nome do cartão -->
        <div class="form-group">
          <label for="surname">Nome igual ao do cartão</label>
          <input type="text" formControlName="surname" placeholder="Nome igual ao do cartão" class="form-control"
            required>
          <div class="invalid-message"
            *ngIf="paymentForm.get('surname')?.invalid && paymentForm.get('surname')?.touched">
            O nome é obrigatório
          </div>
        </div>

        <!-- Número do cartão -->
        <div class="form-group">
          <label for="cardNumber">Número do cartão</label>
          <div class="input-container">
            <input type="text" formControlName="cardNumber" mask="0000 0000 0000 0009" placeholder="1234 1234 1234 1234"
              class="form-control" required>
            <img *ngIf="cardBrandIcon" [src]="cardBrandIcon" [alt]="cardBrandIcon" class="bandeira-icon" />
          </div>
          <div class="invalid-message"
            *ngIf="paymentForm.get('cardNumber')?.invalid && paymentForm.get('cardNumber')?.touched">
            O número do cartão é obrigatório
          </div>
        </div>

        <!-- Validade e CVC -->
        <div class="cielo-row">
          <div class="form-group">
            <label for="validity">Validade</label>
            <input placeholder="MM / AA" mask="00 / 00" formControlName="validity" class="form-control" required>
            <div class="invalid-message"
              *ngIf="paymentForm.get('validity')?.invalid && paymentForm.get('validity')?.touched">
              A validade é obrigatória
            </div>
          </div>
          <div class="form-group">
            <label for="cvc">CVC</label>
            <input formControlName="cvc" mask="0009" type="text" required placeholder="CVC" class="form-control">
            <div class="invalid-message" *ngIf="paymentForm.get('cvc')?.invalid && paymentForm.get('cvc')?.touched">
              O CVC é obrigatório
            </div>
          </div>
        </div>

        <button [disabled]="paymentForm.invalid || loadingPayment" type="button" class="btn-cielo"
          (click)="payWithCard()">
          <span *ngIf="!loadingPayment">Pagar</span>
          <span *ngIf="loadingPayment">Processando...</span>
        </button>
        <div class="cielo-termo">
          <small>
            Seus dados são utilizados apenas para processar este pagamento. Não armazenamos informações do cartão.
          </small>
        </div>
        <div *ngIf="loadingPayment" class="loading-payment-inline">
          <div class="loader"></div>
          <span class="text-neutral-600 text-base font-medium mt-2">
            {{ copy[locale]["loadingPayment"] || 'Processando pagamento...' }}
          </span>
        </div>
      </form>
    </ng-container>
    <ng-template #successMsg>
      <div class="success-message">
        Pagamento em processamento. Aguarde a confirmação.
      </div>
    </ng-template>
  </div>
</div>
